import React from 'react'
import cx from 'classnames'

import s from 'components/_new/controls/ButtonsInRow/ButtonsInRow.scss'


export type ButtonsInRowProps = {
  className?: string
  alignLeft?: boolean
  alignRight?: boolean
  gutter?: null | 8 | 12 | 16
  reversedOnDesktop?: boolean
}

const ButtonsInRow: React.FunctionComponent<ButtonsInRowProps> = (props) => {
  const { className, children, alignLeft, alignRight, gutter = 12, reversedOnDesktop } = props

  const containerClassName = cx(s.twoButtonsInRow, s[`gutter-${gutter}`], {
    [s.alignLeft]: alignLeft,
    [s.alignRight]: alignRight,
    [s.reversedOnDesktop]: reversedOnDesktop,
  })

  return (
    <div className={className}>
      <div className={containerClassName}>
        {children}
      </div>
    </div>
  )
}


export default ButtonsInRow
